var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('event')}}},[_vm._t("btnLabel"),_vm._v(_vm._s(_vm.btnLabel))],2)}
var staticRenderFns = []

export { render, staticRenderFns }